import { cn } from "@/modules/lib/utils"
import { Text } from "@/components/ui/baseUi/text"

type HuBarsProps = {
  number: number
  date: string
  heightBar: number
  className?: string
} & React.ComponentProps<"div">

/**
 * Composant for render chart with bars in the Training page
 * @param number
 * @param date
 * @returns
 */
export function HuBars({ number, date, heightBar, className, ...props }: HuBarsProps) {
  return (
    <div className={cn("flex h-full w-1/4 flex-col items-center justify-end", className)} {...props}>
      <div className="flex h-full flex-row items-end gap-1">
        <Text fontStyle="TM" className="text-textDefault-heading">
          {number}
        </Text>
        <div className="w-3.5 rounded-full bg-surface-inverted" style={{ height: `${heightBar}%` }}></div>
      </div>
      <div className="mt-1">
        <Text fontStyle="BS" className="text-textDefault-heading">
          {date}
        </Text>
      </div>
    </div>
  )
}
